import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { id: "reception-sys" }
const _hoisted_4 = { id: "reservation-sys" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($data.nav_switch == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, { to: "/register" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("仮登録", -1)
                  ]))]),
                  _: 1
                }),
                _cache[8] || (_cache[8] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/sent_confirmation_mail" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("仮登録メール送信完了", -1)
                  ]))]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/success_register" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("仮登録完了", -1)
                  ]))]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("ログイン", -1)
                  ]))]),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/system_error" }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("システムエラー", -1)
                  ]))]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/update" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("本登録", -1)
                  ]))]),
                  _: 1
                }),
                _cache[13] || (_cache[13] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/update_confirmation" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("本登録内容確認", -1)
                  ]))]),
                  _: 1
                }),
                _cache[14] || (_cache[14] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/mypage" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("マイページ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, { to: "/studio_search" }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("空き検索", -1)
                  ]))]),
                  _: 1
                }),
                _cache[19] || (_cache[19] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/studio_detail" }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("予約詳細", -1)
                  ]))]),
                  _: 1
                }),
                _cache[20] || (_cache[20] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/studio_confirm" }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("内容確認", -1)
                  ]))]),
                  _: 1
                }),
                _cache[21] || (_cache[21] = _createTextVNode(" | ", -1)),
                _createVNode(_component_router_link, { to: "/studio_complete" }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("予約完了", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view)
      ])
    ]),
    _: 1
  }))
}